import React, { useState } from 'react';
import HoverIcon from 'components/HoverIcon';
import {
  PermissionScheme,
  PermissionSchemeName,
  PermissionSchemeDescription,
} from './styles';
import PermissionSchemeInput from './PermissionSchemeInput';
import { display } from '../../../../components/ErrorView/ErrorDialog';
import { IProviders } from 'store/store';
import {
  ICompany,
  ICompanyPermissionScheme,
} from 'store/companies/companiesTypes';
import { black } from 'utils/style/colors';

interface IPermissionSchemesListItemProps {
  allTags: IProviders['tags'];
  companyProvidersIdName: [number, string][];
  permissionSchemeItem: ICompanyPermissionScheme;
  allPermissionSchemes: ICompanyPermissionScheme[];
  updatePermissionScheme: (
    permissionScheme: ICompanyPermissionScheme
  ) => Promise<any>;
  deletePermissionScheme: (
    permissionSchemeId: number,
    companyId: number
  ) => () => void;
  company: ICompany;
}

const PermissionSchemesListItem: React.FC<IPermissionSchemesListItemProps> = ({
  permissionSchemeItem,
  deletePermissionScheme,
  updatePermissionScheme,
  allTags,
  companyProvidersIdName,
  company,
}) => {
  const [editing, setEditing] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const processUpdatePermissionScheme = (
    permissionScheme: ICompanyPermissionScheme
  ) => {
    setLoading(true);
    return updatePermissionScheme(permissionScheme)
      .then(() => {
        setLoading(false);
        setEditing(false);
      })
      .catch((err) => {
        display(err);
        setLoading(false);
      });
  };
  return (
    <li style={{ color: black }}>
      {!editing ? (
        <div style={{ display: 'contents' }}>
          <PermissionScheme>
            <PermissionSchemeName>
              {permissionSchemeItem.properties.name}
            </PermissionSchemeName>
            <PermissionSchemeDescription>
              {permissionSchemeItem.properties.description}
            </PermissionSchemeDescription>
          </PermissionScheme>
          {permissionSchemeItem.id && (
            <div>
              <div style={{ float: 'left' }}>
                {!permissionSchemeItem.autoGenerated && (
                  <HoverIcon
                    type="x"
                    color="red"
                    onClick={deletePermissionScheme(
                      permissionSchemeItem.id,
                      permissionSchemeItem.companyId
                    )}
                  />
                )}
                <HoverIcon
                  type={permissionSchemeItem.autoGenerated ? 'eye' : 'edit'}
                  color="cobalt"
                  onClick={() => setEditing(true)}
                />
              </div>
            </div>
          )}
        </div>
      ) : (
        <PermissionSchemeInput
          permissionScheme={permissionSchemeItem}
          addOrUpdatePermissionScheme={processUpdatePermissionScheme}
          loading={loading}
          companyId={permissionSchemeItem.companyId}
          cancelEdit={() => {
            setEditing(false);
          }}
          allTags={allTags}
          companyProvidersIdName={companyProvidersIdName}
          company={company}
        />
      )}
    </li>
  );
};

export default PermissionSchemesListItem;
